module.exports = __webpack_public_path__ + "img/uk-diabetes-mellitus-male.786f7d7a.png";